export const mutateViewsKeys = {
  createView: ['createView'] as const,
  updateView: ['updateView'] as const,
  deleteView: ['deleteView'] as const
};
